import React from 'react'

import s from './styles.module.scss'

import { Button } from '../../../../components/atoms/fields'

interface FooterSubmitInterface {
  label: string
  isLoading: boolean
  onSubmit: () => void
  isValid?: boolean
}

const FooterLogin = ({
  footerElement = <></>,
  submit,
}: {
  footerElement?: JSX.Element
  submit?: FooterSubmitInterface
}) => {
  return (
    <footer className={s.form_footer}>
      <div className={s.footerElement}>{footerElement}</div>
      {submit && (
        <Button
          loading={submit.isLoading}
          onClick={submit.onSubmit}
          disabled={!submit.isValid}
          style={{ flexShrink: 0 }}
          id='send-mail-forgot-password'
          data-testid='login-submit-button'
        >
          {submit.label}
        </Button>
      )}
    </footer>
  )
}

export default FooterLogin
